export default function ServicesHero() {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden bg-[#f0f9f9]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <p className="text-[#418b86] text-xs font-medium tracking-widest uppercase mb-4">What We Offer</p>
          <h1 className="text-4xl md:text-6xl font-light text-[#2d2d2d] leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Support for Every<br />
            <span className="italic font-semibold">Chapter of Life.</span>
          </h1>
          <p className="text-[#6b6b6b] text-base md:text-lg leading-relaxed max-w-xl">
            No matter where you are in your journey, there's a path forward. Our services are designed to meet you exactly where you are — with compassion, clarity, and care.
          </p>
        </div>
      </div>

      {/* Decorative image strip */}
      <div className="mt-14 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-3 gap-4 h-48 md:h-64 rounded-2xl overflow-hidden">
            <div className="overflow-hidden rounded-xl">
              <img
                src="/images/svc1.jpg"
                alt="Peaceful nature"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="overflow-hidden rounded-xl">
              <img
                src="/images/svc2.jpg"
                alt="Calm lake"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="overflow-hidden rounded-xl">
              <img
                src="/images/svc3b.jpg"
                alt="Cozy space"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
